import React, { useState, useEffect } from 'react'

import Navbar from '../../Components/Navbar/Navbar'
import toast from 'react-hot-toast';
import BtnExcel from '../../Components/BtnExcel';

import { 
    Layout,
    Col, 
    Row,
    Button,
    Dropdown, 
    Space,
    Modal,
    Form,
    Table,
    Input,
} from 'antd';
import { formatDate, getTodayDateISO } from '../../Utils/Common';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { MoreVert  } from '@mui/icons-material';
import { UseGetRequest } from '../../Utils/api/ApiRequests'
import { usePostRequest } from '../../hooks/usePostRequest'
import { ProductOutlined } from '@ant-design/icons';

const { Item } = Form;
const { Search } = Input;
const { confirm } = Modal;

const Suppliers = () => {
  const [addVisible, setAddVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [pageSize, setPageSize] = useState('');
  const [supplierId, setSupplierId] = useState('');
  const [excelData, setExcelData] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [tin, setTin] = useState('');
  const [supplierData, setSupplierData] = useState([]);

  const [supplierDetails, setSupplierDetails] = useState({
    name: '',
    address:'',
    contact_person:'',
    contact_no: '',
    description: '',
  });
  const [filterConfig, setFilterConfig] = useState({
    search: '',
    supplier_id: '',
    page: 1,
  })

  const [addForm] = Form.useForm();
  const [editForm] = Form.useForm();
  const { callPost, loading } = usePostRequest(()=>{
    fetchSupplierData()
    addForm.resetFields();
    editForm.resetFields();
    setAddVisible(false);
    setEditVisible(false);
  });
  const customSpinner = <ProductOutlined style={{ fontSize: 24 }} spin />;

  const values1 = Form.useWatch([], addForm);
  React.useEffect(() => {
    addForm.validateFields({
      validateOnly: true,
    }).then(() => {
      setIsDisabled(false);
    },
    () => {
      setIsDisabled(true);
    },
    );
  }, [values1, addForm]);

  const values2 = Form.useWatch([], editForm);
  React.useEffect(() => {
    editForm.validateFields({
      validateOnly: true,
    }).then(() => {
      setIsDisabled(false);
    },
    () => {
      setIsDisabled(true);
    },
    );
  }, [values2, editForm]);

  function ActionBtn(row) {
    const items = [
      {
        label: (
          <div onClick={()=>showEditModal(row.row.id, row.row)}>
            Edit
          </div>
        ),
        key: '2',
      },
      {
        label: (
          <div style={{color: 'red'}} onClick={()=>showDeleteConfirm(row.row.id)}>
            Delete
          </div>
        ),
        key: '3',
      },
    ];

    return (
      <span className='center'>
        <Dropdown
          menu={{
          items,
          }}
          trigger={['click']}
        >
          <div type='primary' onClick={(e) => e.preventDefault()} className='action-btn'>
            <Space>
              <MoreVert />
            </Space>
          </div>
        </Dropdown>
      </span>
    );
  }

  async function fetchSupplierData() {
    setIsLoading(true)
    const response = await UseGetRequest("suppliers/get", filterConfig);
    if (response?.data) {
      setSupplierData(response?.data?.data);
      setPageSize(response?.data?.size)
    } else {
      setSupplierData([])
      setPageSize('')
    }
    setIsLoading(false);
  }

  async function fetchExportData() {
    setExportLoading(true)
    const response = await UseGetRequest("suppliers/get", 
      {
        search: filterConfig.search,
        supplier_id: filterConfig.supplier_id,
      }
    );
    if (response?.data) {
      const excel_data = response.data.data.map((data) => ({
        id: data.id,
        tradename: data.tradename,
        address: data.address,
        contact_no: data.contact_no,
        email: data.email,
        tin: data.tin,
        contact_person: data.contact_person,
        added_on: data.added_on && formatDate(data.added_on),
        updated_on: data.updated_on && formatDate(data.updated_on),
      }))

      setExcelData(excel_data);
      setExportLoading(false);
    } else {
      setExcelData([])
      setExportLoading(false);
    }
  }

  const columns = [
    {
      title: 'Supplier Info',
      key: 'supplier_info',
      render: (_, record) => (
        <>
          <div>Supplier Name: <strong>{record.tradename}</strong></div>
          {(record.tin) && (<div>Tin: <strong>{record.tin}</strong></div>)}
        </>
      ),
    },
    {
      title: 'Contact Info',
      key: 'contact_info',
      render: (_, record) => (
        <>
          {(record.contact_person) && (<div>Contact Person: <strong>{record.contact_person}</strong></div>)}
          {(record.contact_no) &&(<div>Contact Number: <strong>{record.contact_no}</strong></div>)}
          {(record.email) &&(<div>Email Address: <strong>{record.email}</strong></div>)}
        </>
      ),
    },
    {
      // title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      render: (_, record) => (
        <ActionBtn row={record} />
      ),
    },
  ];

  const handleAddOk = () => {
    addForm.validateFields().then(values => {
      const resetData = {
        ...values,
        tin: tin,
      }
      callPost(
        "suppliers/create", 
        resetData,
        false
      );
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const handleEditOk = () => {
    editForm.validateFields().then(values => {
      const resetData = {
        ...values,
        supplier_id: supplierId,
        tin: tin,
      }
      callPost(
        "suppliers/update", 
        resetData,
        false
      );      
    }).catch(errorInfo => {
      toast.error('Validation Failed:', errorInfo);
    });
  };

  const showAddModal = () => {
    setAddVisible(true);
  };

  const showEditModal = (id, supplier_data) => {
    setSupplierId(id) 
    setSupplierDetails(() => ({
      tradename: supplier_data.tradename,
      address: supplier_data.address,
      contact_person: supplier_data.contact_person,
      contact_no: supplier_data.contact_no,
      email: supplier_data.email,
      tin: supplier_data.tin,
    }));     
    editForm.setFieldsValue({
      tradename: supplier_data.tradename,
      address: supplier_data.address,
      contact_person: supplier_data.contact_person,
      contact_no: supplier_data.contact_no,
      email: supplier_data.email,
      tin: supplier_data.tin,
    });
    setTin(supplier_data.tin)
    setEditVisible(true);
  };

  const handleAddCancel = () => {
    addForm.resetFields();
    setAddVisible(false);
  };

  const handleEditCancel = () => {
    editForm.resetFields();
    setEditVisible(false);
  };

  const showDeleteConfirm = (id) => {
    confirm({
      title: 'Do you want to permanently remove this supplier?',
      icon: <ExclamationCircleFilled/>,
      content: 'This action cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      okButtonProps: {
        className: 'custom-yes-button',
      },
      cancelButtonProps: {
        className: 'custom-no-button',
      },
      confirmLoading: loading,
      onOk() {
        callPost(
          "suppliers/delete", 
          {supplier_id: id},
          false
        );
      },
    });
  };

  const handleSearchChange = (e) => {
    setFilterConfig((prev) => (
      {
        ...prev,
        search: e || '',
        page: 1,
      }
    ));
  };

  const handleEmpty = (e) => {
    if(e.target.value === ''){
      setFilterConfig((prev) => (
        {
          ...prev,
          search: e.target.value || '',
          page: 1,
        }
      ));
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;
    if (/^[0-9.-]*$/.test(value)) {
      setTin(value);
    }
  };

  const handleTableChange = (pagination) => {
    setFilterConfig((prev) => ({
      ...prev,
      page: parseInt(pagination.current),
      page_size: pagination.pageSize
      // total_records_per_page: pagination.pageSize,
    }));
  };

  const pageSizeOptions = ['10', '20', '50', '100', `${pageSize}`];
  const sortedPageSizeOptions = pageSizeOptions.filter(item => item <= pageSize).sort((a, b) => Number(a) - Number(b)); 

  useEffect(() => {
    fetchSupplierData();
    fetchExportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className='page'>
      <Navbar navKey={'supplier_nav'}/>
      <Layout className='content-container'>
        <Row className='custom-padding responsive-inline responsive-tab-inline'>
          <Col span={12} className='header-container'>
              SUPPLIER
          </Col>
          <Col span={12} className='mt-2 responsive-tab-width' align='end'>
            <Space className='responsive-inline'>
              <BtnExcel
                label={"Export to Excel"}
                size={"sm"}
                excelData={excelData}
                xlsxHeaders={[
                  "ID",
                  "Tradename",
                  "Address",
                  "Contact Number",
                  "Email",
                  "Tin",
                  "Contact Person",
                  "Added On",
                  "Updated On",
                ]}
                handleData={fetchExportData}
                isClicked={exportLoading}
                fileName={`Suppliers_${getTodayDateISO()}.xlsx`}
              />

              <Button 
                className='button-color responsive-header-btn'
                onClick={showAddModal} 
                type="primary"
              >
                + Add Supplier
              </Button>   
            </Space>
          </Col>
        </Row>
        <Row>
          <Space span={24} className='responsive-inline excel-row'>
            <Search
              placeholder="Search..."
              size='medium'
              onSearch={(e)=>handleSearchChange(e)}
              onChange={(e)=>handleEmpty(e)}
              className='responsive-header-input'
            />     
          </Space> 
        </Row>
        <Row className='page-content'>
          <Col span={24} className='responsive-overflow-auto'>
            <Table 
              columns={columns} 
              dataSource={supplierData} 
              loading={{
                indicator: customSpinner,
                spinning: isLoading,
              }}
              pagination={{
                defaultPageSize: 10,
                pageSizeOptions: sortedPageSizeOptions,
                showSizeChanger: true,
                total: pageSize,
                current: filterConfig?.page,
                pageSize: filterConfig?.total_records_per_page,
              }}
              onChange={handleTableChange}
            />
          </Col>
        </Row>
      </Layout>
      <Modal
        title="Add Supplier"
        open={addVisible}
        onOk={handleAddOk}
        confirmLoading={loading}
        onCancel={handleAddCancel}
        okButtonProps={{ disabled: isDisabled }}
      >
      <Form form={addForm} layout="vertical">
          <Item
            label="Tradename"
            name="tradename"
            rules={[{ required: true, message: 'Please enter your Tradename!' }]}
          >
            <Input />
          </Item>
          <Item
            className='mb-4'
            label="Address"
            name="address"
          >
            <Input />
          </Item>
          <Item
            className='mb-4'
            label="Contact Person"
            name="contact_person"
          >
            <Input />
          </Item>
          <Item
            className='mb-4'
            label="Contact Number"
            name="contact_no"
          >
            <Input />
          </Item>
          <Item
            className='mb-4'
            label="Email"
            name="email"
          >
            <Input />
          </Item>
          <div>
            Tin
          </div>
          <Input
            value={tin}
            onChange={handleChange}
          />
        </Form>
      </Modal>
      <Modal
        title="Edit Supplier"
        open={editVisible}
        confirmLoading={loading}
        onOk={handleEditOk}
        onCancel={handleEditCancel}
        okButtonProps={{ disabled: isDisabled }}
      >
        <Form 
          form={editForm} 
          layout="vertical"
          initialValues={supplierDetails}
        >
          <Item
            label="Tradename"
            name="tradename"
            rules={[{ required: true, message: 'Please enter your Tradename!' }]}
          >
            <Input />
          </Item>
          <Item
            className='mb-4'
            label="Address"
            name="address"
          >
            <Input />
          </Item>
          <Item
            className='mb-4'
            label="Contact Person"
            name="contact_person"
          >
            <Input />
          </Item>
          <Item
            className='mb-4'
            label="Contact Number"
            name="contact_no"
          >
            <Input />
          </Item>
          <Item
            className='mb-4'
            label="Email"
            name="email"
          >
            <Input />
          </Item>
          <div>
            Tin
          </div>
          <Input
            value={tin}
            onChange={handleChange}
          />
        </Form>
      </Modal>
    </Layout>
  )
}
export default Suppliers
